// Name must be unique and is showed to user if they can manage permissions
// (type: 'manageable')
// Otherwise required but meaningless
//
// CODE must be unique and is used in front to prevent updating every href when a route is changed

module.exports.routes = [{
  name: 'Sitemap',
  back: {
    url: '/sitemap.xml',
    controller: 'SitemapController',
    action: 'generate',
    skipAssets: false
  },
  type: 'public'
}, {
  name: 'fetchPageInfos',
  back: {
    url: 'POST /fetch-page-infos',
    controller: 'RouteController',
    action: 'fetchPageInfos',
    CODE: 'FetchPageInfos'
  },
  type: 'public'
}, {
  name: 'getFile',
  back: {
    url: 'GET /upload/:model/:id/files/:filename',
    controller: 'RessourcesController',
    action: 'getFile',
    skipAssets: false
  },
  type: 'public'
}, {
  name: 'getFileInDirectory',
  back: {
    url: 'GET /upload/:model/:id/:directory/:filename',
    controller: 'RessourcesController',
    action: 'getFile',
    skipAssets: false
  },
  type: 'public'
},
/*
	========================================================
	------------------------- Front ------------------------
	========================================================
*/
{
  name: 'GET /maintenance',
  CODE: 'MaintenancePage',
  front: {
    url: '/maintenance',
    reactComponent: 'MaintenancePage'
  },
  TC_hold: true,
  type: 'public'
}, {
  name: 'GET /',
  CODE: 'HomePage',
  front: {
    url: '/',
    reactComponent: 'HomePage'
  },
  sitemap: {
    priority: 1,
    changefreq: 'weekly'
  },
  TC_template: 'homepage',
  TC_page: 'homepage',
  type: 'public'
}, {
  name: 'GET /login',
  CODE: 'Login',
  front: {
    url: '/login',
    reactComponent: 'LoginPage'
  },
  TC_template: 'connexion',
  TC_page: 'connexion',
  type: 'public'
}, {
  name: 'SignInWithThirdParty',
  CODE: 'SignInWithThirdParty',
  front: {
    url: '/connexion-tierce',
    reactComponent: 'SignInWithThirdPartyPage'
  },
  type: 'public'
}, {
  name: 'GET /connexion-client',
  CODE: 'CustomerLogin',
  front: {
    url: '/connexion-client',
    reactComponent: 'CustomerLoginPage'
  },
  sitemap: {
    priority: .2,
    changefreq: 'yearly'
  },
  TC_template: 'Connexion client',
  TC_page: 'Connexion client',
  TC_business: 'btoc',
  type: 'public'
}, {
  name: 'GET /connexion-employe-entreprise',
  CODE: 'CompanyEmployeeLogin',
  front: {
    url: '/connexion-employe-entreprise',
    reactComponent: 'CompanyEmployeeLoginPage'
  },
  sitemap: {
    priority: .2,
    changefreq: 'yearly'
  },
  TC_template: 'Connexion professionnel',
  TC_page: 'Connexion professionnel',
  type: 'public'
}, {
  name: 'GET /connexion-entreprise',
  CODE: 'CompanyLogin',
  front: {
    url: '/connexion-entreprise',
    reactComponent: 'CompanyLoginPage'
  },
  sitemap: {
    priority: .2,
    changefreq: 'yearly'
  },
  TC_template: 'Connexion entreprise',
  TC_page: 'Connexion entreprise',
  type: 'public'
}, {
  name: 'GET /inscription',
  CODE: 'CustomerInscriptionPage',
  front: {
    url: '/inscription',
    reactComponent: 'CustomerInscriptionPage'
  },
  sitemap: {
    priority: .2,
    changefreq: 'yearly'
  },
  TC_template: 'my account',
  TC_page: 'inscription',
  TC_business: 'btoc',
  type: 'public'
}, {
  name: 'FrontSearch',
  CODE: 'FrontSearch',
  front: {
    url: '/recherche/:type/:city',
    reactComponent: 'SearchResultsPage',
    skipAssets: true
  },
  TC_template: 'listing',
  TC_hold: true,
  TC_with_booking_type: true,
  type: 'public'
}, {
  name: 'FrontSearchWithoutCity',
  CODE: 'FrontSearchWithoutCity',
  front: {
    url: '/recherche/:type',
    reactComponent: 'SearchResultsPage',
    skipAssets: true
  },
  TC_template: 'listing',
  TC_hold: true,
  TC_with_booking_type: true,
  type: 'public'
}, {
  name: 'GET /etablissements/:slug',
  CODE: 'FrontEtablishmentPage',
  front: {
    url: '/etablissements/:slug',
    reactComponent: 'FrontEtablishmentPage'
  },
  TC_template: 'fiche établissement',
  TC_hold: true,
  TC_with_booking_type: true,
  type: 'public'
}, {
  name: 'FrontDirectBookingPage',
  CODE: 'FrontDirectBookingPage',
  front: {
    url: '/etablissements/:slug/reservation',
    reactComponent: 'DirectBookingPage'
  },
  TC_template: 'reservation',
  TC_page: 'reservation',
  TC_with_booking_type: true,
  TC_business: 'btoc',
  type: 'public'
}, {
  name: 'GET /etablissements/:slug/formulaire-client',
  CODE: 'FrontEtablishmentSubscriptionPage',
  front: {
    url: '/etablissements/:slug/formulaire-client',
    reactComponent: 'EtablishmentSubscriptionPage'
  },
  TC_template: 'qr code',
  TC_hold: true,
  TC_with_booking_type: true,
  type: 'public'
}, {
  name: 'GetCaptainWalletUrl',
  back: {
    url: 'POST /captain-wallet/get-url',
    controller: 'UserController',
    action: 'getCaptainWalletUrl',
    CODE: 'GetCaptainWalletUrl'
  },
  type: 'connected'
}, {
  name: 'GET /etablissements/:slug/:space',
  CODE: 'FrontSpacePage',
  front: {
    url: '/etablissements/:slug/:space',
    reactComponent: 'FrontSpacePage'
  },
  TC_template: 'fiche produit',
  TC_hold: true,
  TC_with_booking_type: true,
  type: 'public'
}, {
  name: 'GET /notre-concept',
  CODE: 'ConceptPage',
  front: {
    url: '/notre-concept',
    reactComponent: 'ConceptPage'
  },
  sitemap: {
    priority: .5,
    changefreq: 'yearly'
  },
  TC_template: 'Notre concept',
  TC_page: 'Notre concept',
  type: 'public'
}, {
  name: 'GET /offre-entreprise',
  CODE: 'CompanyOfferPage',
  front: {
    url: '/offre-entreprise',
    reactComponent: 'CompanyOfferPage'
  },
  sitemap: {
    priority: .5,
    changefreq: 'yearly'
  },
  TC_template: 'Offre entreprise',
  TC_page: 'Offre entreprise',
  type: 'public'
}, {
  name: 'GET /actualites',
  CODE: 'AllNewsPage',
  front: {
    url: '/actualites',
    reactComponent: 'AllNewsPage'
  },
  sitemap: {
    priority: .5,
    changefreq: 'yearly',
    lastmod: '2023-10-27T11:34:00+02:00'
  },
  TC_template: 'Toutes les actualités',
  TC_page: 'Toutes les actualités',
  type: 'public'
}, {
  name: 'GET /actualites/:slug',
  CODE: 'NewsPage',
  front: {
    url: '/actualites/:slug',
    reactComponent: 'NewsPage'
  },
  TC_template: 'actualites',
  TC_page: 'actualite',
  TC_hold: true,
  type: 'public'
}, {
  name: 'getAllFrontSpaces',
  back: {
    url: 'POST /front/space/get-all',
    controller: 'FrontController',
    action: 'getAllSpaces',
    CODE: 'getAllFrontSpaces'
  },
  type: 'public'
}, {
  name: 'getAllFrontEtablishments',
  back: {
    url: 'POST /front/etablishment/get-all',
    controller: 'FrontController',
    action: 'getAllEtablishments',
    CODE: 'getAllFrontEtablishments'
  },
  type: 'public'
}, {
  name: 'fetchEstablishmentDetails',
  back: {
    url: 'POST /front/get-etablishment-details',
    controller: 'FrontController',
    action: 'getEstablishmentDetails',
    CODE: 'fetchEstablishmentDetails'
  },
  type: 'public'
}, {
  name: 'GetEstablishmentForMap',
  back: {
    url: 'POST /front/get-establishment-for-map',
    controller: 'FrontController',
    action: 'getEstablishmentForMap',
    CODE: 'GetEstablishmentForMap'
  },
  type: 'public'
}, {
  name: 'getEtablishment',
  back: {
    url: 'POST /admin/get-etablishment',
    controller: 'EtablishmentController',
    action: 'get',
    CODE: 'getEtablishment'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'getEtablishmentsForAdminSelection',
  back: {
    url: 'POST /admin/get-etablishments-for-selection',
    controller: 'EtablishmentController',
    action: 'getForAdminSelection',
    CODE: 'getEtablishmentsForAdminSelection'
  },
  type: 'AdminOnly'
}, {
  name: 'switchEtablishment',
  back: {
    url: 'POST /admin/switch-etablishment',
    controller: 'UserController',
    action: 'switchEtablishment',
    CODE: 'switchEtablishment'
  },
  type: 'AdminOnly'
}, {
  name: 'searchAllEtablishments',
  back: {
    url: 'POST /front/etablishment/search',
    controller: 'FrontController',
    action: 'searchEtablishments',
    CODE: 'searchAllEtablishments'
  },
  type: 'public'
}, {
  name: 'LegalPage',
  CODE: 'LegalPage',
  front: {
    url: '/mentions-legales',
    reactComponent: 'LegalPage'
  },
  type: 'public'
}, {
  name: 'CGUPage',
  CODE: 'CGUPage',
  front: {
    url: '/conditions-generales',
    reactComponent: 'CGUPage'
  },
  type: 'public'
}, {
  name: 'FrontBookingPage',
  CODE: 'FrontBookingPage',
  front: {
    url: '/reserver-en-ligne',
    reactComponent: 'FrontBookingPage'
  },
  TC_template: 'reservation',
  TC_page: 'reservation',
  TC_with_booking_type: true,
  TC_hold: true,
  type: 'public'
}, {
  name: 'EtablishmentsMapPage',
  CODE: 'EtablishmentsMapPage',
  front: {
    url: '/carte-des-etablissements',
    reactComponent: 'EtablishmentsMapPage'
  },
  type: 'public'
}, {
  name: 'CustomerBookingsDashboardPage',
  CODE: 'CustomerBookingsDashboard',
  front: {
    url: '/reservations',
    reactComponent: 'CustomerBookingsDashboardPage'
  },
  type: 'manageable',
  TC_template: 'my account',
  TC_page: 'Mes réservations',
  TC_business: 'btoc',
  roles: ['customer']
}, {
  name: 'EmployeeBookingsDashboardPage',
  CODE: 'EmployeeBookingsDashboard',
  front: {
    url: '/mes-reservations',
    reactComponent: 'EmployeeBookingsDashboardPage'
  },
  TC_template: 'my account',
  TC_page: 'Mes réservations',
  type: 'manageable',
  roles: ['company_employee']
}, {
  name: 'CustomerAccountPage',
  CODE: 'CustomerAccount',
  front: {
    url: '/mon-compte',
    reactComponent: 'CustomerAccountPage'
  },
  TC_template: 'my account',
  TC_page: 'Mon compte',
  TC_business: 'btoc',
  type: 'manageable',
  roles: ['customer']
}, {
  name: 'WalletCardPage',
  CODE: 'WalletCard',
  front: {
    url: '/ma-carte-myWO',
    reactComponent: 'WalletCardPage'
  },
  TC_template: 'my wallet card',
  TC_page: 'Ma carte myWO',
  TC_business: 'btoc',
  type: 'manageable',
  roles: ['customer']
}, {
  name: 'CompanyCreateAccountPage',
  CODE: 'CompanyCreateAccount',
  front: {
    url: '/creation-compte-entreprise',
    reactComponent: 'CompanyCreateAccountPage'
  },
  sitemap: {
    priority: .2,
    changefreq: 'yearly'
  },
  TC_template: 'my account',
  TC_page: 'inscription',
  type: 'public'
},
/*
	========================================================
	------------------------- Back -------------------------
	========================================================
*/

/* ------------------------- User ------------------------- */

{
  name: 'GET /liste-des-utilisateurs',
  CODE: 'AdminUsersDashboard',
  front: {
    url: '/liste-des-utilisateurs',
    reactComponent: 'UsersDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-utilisateurs/nouvel-utilisateur',
  CODE: 'NewUser',
  front: {
    url: '/liste-des-utilisateurs/nouvel-utilisateur',
    reactComponent: 'NewUserPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-utilisateurs/:id',
  front: {
    url: '/liste-des-utilisateurs/:id',
    reactComponent: 'UpdateUserPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /user/get-all',
  back: {
    url: 'POST /user/get-all',
    controller: 'UserController',
    action: 'getAll',
    CODE: 'getAllUsers'
  },
  type: 'connected',
  roles: ['hotelier', 'marketing']
}, {
  name: 'GetAccount',
  back: {
    url: 'POST /user/get-account',
    controller: 'UserController',
    action: 'getAccount',
    CODE: 'GetAccount'
  },
  type: 'connected'
}, {
  name: 'POST /user/create',
  back: {
    url: 'POST /user/create',
    controller: 'UserController',
    action: 'create'
  },
  type: 'public'
}, {
  name: 'Register',
  back: {
    CODE: 'Register',
    url: 'POST /user/register',
    controller: 'UserController',
    action: 'register'
  },
  type: 'public'
}, {
  name: 'POST /user/update',
  back: {
    url: 'POST /user/update',
    controller: 'UserController',
    action: 'update',
    CODE: 'UpdateUser'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier', 'customer']
}, /* ------------------------- Company ------------------------- */

{
  name: 'GET /liste-des-entreprises',
  CODE: 'AdminCompaniesDashboard',
  front: {
    url: '/liste-des-entreprises',
    reactComponent: 'AdminCompaniesDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-entreprises/nouvelle-entreprise',
  CODE: 'AdminNewCompany',
  front: {
    url: '/liste-des-entreprises/nouvelle-entreprise',
    reactComponent: 'NewCompanyPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-entreprises/:id',
  front: {
    url: '/liste-des-entreprises/:id',
    reactComponent: 'UpdateCompanyPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /entreprise/informations',
  CODE: 'CompanyInformation',
  front: {
    url: '/entreprise/informations',
    reactComponent: 'CompanyInformationPage'
  },
  type: 'manageable',
  TC_template: 'B2B_company_bo',
  TC_page: 'Page entreprise',
  roles: ['admin', 'hotelier', 'company']
}, {
  name: 'POST /company/get-all',
  back: {
    url: 'POST /company/get-all',
    controller: 'CompanyController',
    action: 'getAll',
    CODE: 'getAllCompanies'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier', 'company']
}, {
  name: 'POST /company/register',
  back: {
    url: 'POST /company/register',
    controller: 'CompanyController',
    action: 'register',
    CODE: 'RegisterNewCompany'
  },
  type: 'public'
}, {
  name: 'POST /company/admin-create',
  back: {
    url: 'POST /company/admin-create',
    controller: 'CompanyController',
    action: 'adminCreate',
    CODE: 'AdminCreateCompany'
  },
  type: 'public'
}, {
  name: 'POST /company/admin-update',
  back: {
    url: 'POST /company/admin-update',
    controller: 'CompanyController',
    action: 'update',
    CODE: 'AdminUpdateCompany'
  },
  type: 'manageable',
  roles: ['admin']
}, {
  name: 'POST /company/update-my-company',
  back: {
    url: 'POST /company/update-my-company',
    controller: 'CompanyController',
    action: 'updateMyCompany',
    CODE: 'UpdateMyCompany'
  },
  type: 'manageable',
  roles: ['company']
}, /* ------------------------- Etablishment ------------------------- */

{
  name: 'GET /liste-des-etablissements',
  CODE: 'AdminEtablishmentsDashboard',
  front: {
    url: '/liste-des-etablissements',
    reactComponent: 'EtablishmentsDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-etablissements/nouvel-etablissement',
  CODE: 'NewEtablishment',
  front: {
    url: '/liste-des-etablissements/nouvel-etablissement',
    reactComponent: 'NewEtablishmentPage'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'GET /liste-des-etablissements/:id',
  CODE: 'UpdateEtablishmentPage',
  front: {
    url: '/liste-des-etablissements/:id',
    reactComponent: 'UpdateEtablishmentPage'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'getAllEtablishments',
  back: {
    url: 'POST /etablishment/get-all',
    controller: 'EtablishmentController',
    action: 'getAll',
    CODE: 'getAllEtablishments'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier', 'marketing']
}, {
  name: 'POST /etablishment/create',
  back: {
    url: 'POST /etablishment/create',
    controller: 'EtablishmentController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /etablishment/update',
  back: {
    url: 'POST /etablishment/update',
    controller: 'EtablishmentController',
    action: 'update',
    CODE: 'UpdateEtablishment'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'POST /etablishment/delete',
  back: {
    url: 'POST /etablishment/delete',
    controller: 'EtablishmentController',
    action: 'delete'
  },
  type: 'manageable',
  roles: ['admin']
}, {
  name: 'GET /exporter-donnees-etablissements',
  CODE: 'ExportEstablishmentsData',
  front: {
    url: '/exporter-donnees-etablissements',
    reactComponent: 'ExportHotelsDataPage'
  },
  type: 'manageable',
  roles: ['admin']
}, {
  name: 'etablishmentToCSV',
  back: {
    url: 'GET /admin/exportHotelDataCSV',
    controller: 'EtablishmentController',
    action: 'exportHotelDataCSV',
    CODE: 'exportHotelDataCSV'
  },
  type: 'adminOnly'
}, {
  name: 'getImagesArchive',
  back: {
    url: 'POST /admin/images-archive-export',
    controller: 'EtablishmentController',
    action: 'getImagesArchive',
    CODE: 'getImagesArchive'
  },
  type: 'adminOnly'
}, /* ------------------------- Service ------------------------- */

{
  name: 'GET /liste-des-services',
  CODE: 'AdminServicesDashboard',
  front: {
    url: '/liste-des-services',
    reactComponent: 'ServicesDashboardPage'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'GET /liste-des-services/nouveau-service',
  CODE: 'NewService',
  front: {
    url: '/liste-des-services/nouveau-service',
    reactComponent: 'NewServicePage'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'GET /liste-des-services/:id',
  front: {
    url: '/liste-des-services/:id',
    reactComponent: 'UpdateServicePage'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'POST /service/get-all',
  back: {
    url: 'POST /service/get-all',
    controller: 'ServiceController',
    action: 'getAll',
    CODE: 'getAllServices'
  },
  type: 'public'
}, {
  name: 'POST /service/create',
  back: {
    url: 'POST /service/create',
    controller: 'ServiceController',
    action: 'create'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'POST /service/update',
  back: {
    url: 'POST /service/update',
    controller: 'ServiceController',
    action: 'update'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'POST /service/delete',
  back: {
    url: 'POST /service/delete',
    controller: 'ServiceController',
    action: 'delete'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, /* ------------------------- ServiceTitle ------------------------- */

{
  name: 'GET /liste-des-titres-de-service',
  CODE: 'AdminServiceTitlesDashboard',
  front: {
    url: '/liste-des-titres-de-service',
    reactComponent: 'ServiceTitlesDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-titres-de-service/nouveau-titre',
  CODE: 'NewServiceTitle',
  front: {
    url: '/liste-des-titres-de-service/nouveau-titre',
    reactComponent: 'NewServiceTitlePage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-titres-de-service/:id',
  front: {
    url: '/liste-des-titres-de-service/:id',
    reactComponent: 'UpdateServiceTitlePage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /servicetitle/get-all',
  back: {
    url: 'POST /servicetitle/get-all',
    controller: 'ServiceTitleController',
    action: 'getAll',
    CODE: 'getAllServiceTitles'
  },
  type: 'public'
}, {
  name: 'POST /servicetitle/create',
  back: {
    url: 'POST /servicetitle/create',
    controller: 'ServiceTitleController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /servicetitle/update',
  back: {
    url: 'POST /servicetitle/update',
    controller: 'ServiceTitleController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /servicetitle/delete',
  back: {
    url: 'POST /servicetitle/delete',
    controller: 'ServiceTitleController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, /* ------------------------- Pack ------------------------- */

{
  name: 'GET /liste-des-packs',
  CODE: 'AdminPacksDashboard',
  front: {
    url: '/liste-des-packs',
    reactComponent: 'PacksDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /acheter-des-packs',
  CODE: 'BuyPacks',
  front: {
    url: '/acheter-des-packs',
    reactComponent: 'BuyPacksPage'
  },
  type: 'manageable',
  TC_template: 'confirmation_B2B',
  TC_page: 'B2B_achat_packs',
  roles: ['company']
}, {
  name: 'GET /mes-packs',
  CODE: 'MyPacks',
  front: {
    url: '/mes-packs',
    reactComponent: 'MyPacksPage'
  },
  type: 'manageable',
  TC_template: 'B2B_company_bo',
  TC_page: 'B2B_packs',
  roles: ['company']
}, {
  name: 'GET /liste-des-packs/nouveau-pack',
  CODE: 'NewPack',
  front: {
    url: '/liste-des-packs/nouveau-pack',
    reactComponent: 'NewPackPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-packs/:id',
  front: {
    url: '/liste-des-packs/:id',
    reactComponent: 'UpdatePackPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /pack/get-all',
  back: {
    url: 'POST /pack/get-all',
    controller: 'PackController',
    action: 'getAll',
    CODE: 'getAllPacks'
  },
  type: 'public'
}, {
  name: 'POST /pack/create',
  back: {
    url: 'POST /pack/create',
    controller: 'PackController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /pack/update',
  back: {
    url: 'POST /pack/update',
    controller: 'PackController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /pack/delete',
  back: {
    url: 'POST /pack/delete',
    controller: 'PackController',
    action: 'delete'
  },
  type: 'AdminOnly'
}, /* ------------------------- PackOrder ------------------------- */
{
  name: 'GET /mes-commandes',
  CODE: 'MyOrders',
  front: {
    url: '/mes-commandes',
    reactComponent: 'MyOrdersPage'
  },
  type: 'manageable',
  TC_template: 'my account',
  TC_page: 'Mes commandes',
  roles: ['company']
}, {
  name: 'GET /liste-de-mes-reservations',
  CODE: 'MyBookings',
  front: {
    url: '/liste-de-mes-reservations',
    reactComponent: 'CompanyBookingsDashboardPage'
  },
  type: 'manageable',
  TC_template: 'my account',
  TC_page: 'Mes réservations',
  roles: ['company']
}, {
  name: 'GET /liste-des-commandes',
  CODE: 'AdminPackOrdersDashboard',
  front: {
    url: '/liste-des-commandes',
    reactComponent: 'AdminPackOrdersDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /export-commandes',
  CODE: 'AdminExportsOrder',
  front: {
    url: '/export-commandes',
    reactComponent: 'AdminExportsOrderPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /export-commandes-marketing',
  CODE: 'ExportBtoCMarketingDashboard',
  front: {
    url: '/export-reservations-marketing',
    reactComponent: 'ExportBtoCMarketingDashboardPage'
  },
  type: 'manageable',
  roles: ['marketing', 'admin']
}, {
  name: 'GET /liste-des-commandes/nouvelle-commande',
  CODE: 'NewPackOrder',
  front: {
    url: '/liste-des-commandes/nouvelle-commande',
    reactComponent: 'NewPackOrderPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /packorder/get-all',
  back: {
    url: 'POST /packorder/get-all',
    controller: 'PackOrderController',
    action: 'getAll',
    CODE: 'getAllPackOrders'
  },
  type: 'manageable',
  roles: ['company', 'admin']
}, {
  name: 'GET /export/commande',
  back: {
    url: 'GET /export/commande',
    controller: 'PackOrderController',
    action: 'export',
    skipAssets: false,
    CODE: 'exportPackOrders'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /export/commande-b2c',
  back: {
    url: 'GET /export/commande-b2c',
    controller: 'BookingController',
    action: 'export',
    skipAssets: false,
    CODE: 'exportBooking'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /export/commande-b2c-offline',
  back: {
    url: 'GET /export/commande-b2c-offline',
    controller: 'BookingController',
    action: 'exportBookingOffline',
    skipAssets: false,
    CODE: 'exportBooking'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /export/marketing-commande-b2c',
  back: {
    url: 'GET /export/marketing-commande-b2c',
    controller: 'BookingController',
    action: 'exportOrderMarketing',
    skipAssets: false,
    CODE: 'exportOrderMarketing'
  },
  type: 'manageable',
  roles: ['marketing']
}, {
  name: 'GET /export/marketing-clients-b2c',
  back: {
    url: 'GET /export/marketing-clients-b2c',
    controller: 'BookingController',
    action: 'exportCustomerMarketing',
    skipAssets: false,
    CODE: 'exportCustomerMarketing'
  },
  type: 'manageable',
  roles: ['marketing']
}, {
  name: 'POST /packorder/validate-order-form',
  back: {
    url: 'POST /packorder/validate-order-form',
    controller: 'PackOrderController',
    action: 'validateOrderForm',
    CODE: 'validateOrderForm'
  },
  type: 'public'
}, {
  name: 'POST /packorder/payment-by-card',
  back: {
    url: 'POST /packorder/payment-by-card',
    controller: 'PackOrderController',
    action: 'validateOrderByCard'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'POST /packorder/payment-by-order-form',
  back: {
    url: 'POST /packorder/payment-by-order-form',
    controller: 'PackOrderController',
    action: 'validateOrderByOrderForm'
  },
  type: 'manageable',
  roles: ['company']
}, {
  name: 'POST /packorder/init-payment',
  back: {
    url: 'POST /packorder/init-payment',
    controller: 'PackOrderController',
    action: 'initPayment',
    CODE: 'InitilizePackOrderPayment'
  },
  type: 'public'
}, {
  name: 'POST /packorder/authorize-payment',
  back: {
    url: 'POST /packorder/authorize-payment',
    controller: 'PackOrderController',
    action: 'authorizePayment',
    CODE: 'AuthorizePackOrderPayment'
  },
  type: 'public'
}, {
  name: 'POST /company-booking/validate',
  back: {
    url: 'POST /company-booking/validate',
    controller: 'PackOrderController',
    action: 'validateBooking',
    CODE: 'CreateCompanyBooking'
  },
  type: 'public'
}, {
  name: 'POST /packorder/delete',
  back: {
    url: 'POST /packorder/delete',
    controller: 'PackOrderController',
    action: 'delete',
    CODE: 'DeletePackOrder'
  },
  type: 'manageable',
  roles: ['company']
}, /* ------------------------- PackOrderIndex ------------------------- */

{
  name: 'GET /liste-des-packs-achetes',
  CODE: 'AdminPackOrdersIndexDashboard',
  front: {
    url: '/liste-des-packs-achetes',
    reactComponent: 'AdminPackOrdersIndexDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-packs-achetes/:id',
  front: {
    url: '/liste-des-packs-achetes/:id',
    reactComponent: 'UpdatePackOrderIndexPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /packorderindex/get-all',
  back: {
    url: 'POST /packorderindex/get-all',
    controller: 'PackOrderIndexController',
    action: 'getAll',
    CODE: 'getAllPackOrdersIndex'
  },
  type: 'public'
}, {
  name: 'POST /packorderindex/update',
  back: {
    url: 'POST /packorderindex/update',
    controller: 'PackOrderIndexController',
    action: 'update',
    CODE: 'updatePackOrderIndex'
  },
  type: 'AdminOnly'
}, {
  name: 'getPackOrderIndexPDF',
  back: {
    url: 'GET /pack/PDF/:packorder_id',
    controller: 'PDFController',
    action: 'getPackOrderIndexPDF',
    CODE: 'getPackOrderIndexPDF'
  },
  type: 'manageable',
  roles: ['company', 'admin']
}, {
  name: 'getQRCodePDF',
  back: {
    url: 'GET /mon-affiche/:etablishment_id/mon-affiche-myWo-:id_property',
    controller: 'EtablishmentController',
    action: 'getQRCodePDF',
    CODE: 'getQRCodePDF'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, /* ------------------------- CoworkingSpace ------------------------- */

{
  name: 'GET /liste-des-espaces-coworking',
  CODE: 'AdminCoworkingSpacesDashboard',
  front: {
    url: '/liste-des-espaces-coworking',
    reactComponent: 'CoworkingSpacesDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'GET /liste-des-espaces-coworking/nouvel-espace-coworking',
  CODE: 'NewCoworkingSpace',
  front: {
    url: '/liste-des-espaces-coworking/nouvel-espace-coworking',
    reactComponent: 'NewCoworkingSpacePage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'GET /liste-des-espaces-coworking/:id',
  front: {
    url: '/liste-des-espaces-coworking/:id',
    reactComponent: 'UpdateCoworkingSpacePage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /coworking-space/get-all',
  back: {
    url: 'POST /coworking-space/get-all',
    controller: 'CoworkingSpaceController',
    action: 'getAll',
    CODE: 'getAllCoworkingSpaces'
  },
  type: 'public'
}, {
  name: 'POST /coworking-space/create',
  back: {
    url: 'POST /coworking-space/create',
    controller: 'CoworkingSpaceController',
    action: 'create'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /coworking-space/update',
  back: {
    url: 'POST /coworking-space/update',
    controller: 'CoworkingSpaceController',
    action: 'update'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'GET /gestion-des-prix',
  CODE: 'PriceConfigurationDashboard',
  front: {
    url: '/gestion-des-prix',
    reactComponent: 'PriceConfigurationDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /coworking-space/get-spaces',
  back: {
    url: 'POST /coworking-space/get-spaces',
    controller: 'CoworkingSpaceController',
    action: 'getSpaces',
    CODE: 'getSpacesSpaces'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'GET /coworking-space/export-space-availabality-csv',
  back: {
    url: 'GET /coworking-space/export-spaces-availabality-csv',
    controller: 'CoworkingSpaceController',
    action: 'exportSpaceAvailabalityCsv',
    CODE: 'exportSpaceAvailabalityCsv'
  },
  type: 'adminOnly'
}, {
  name: 'POST /coworking-space/set-prices',
  back: {
    url: 'POST /coworking-space/set-prices',
    controller: 'CoworkingSpaceController',
    action: 'setPrices',
    CODE: 'setPricesSpaces'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'GET /disponibilites/gestion',
  CODE: 'ScheduleConfigurationDashboard',
  front: {
    url: '/disponibilites/gestion',
    reactComponent: 'ScheduleConfigurationDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'GET /disponibilites/affichage',
  CODE: 'ScheduleDashboard',
  front: {
    url: '/disponibilites/affichage',
    reactComponent: 'ScheduleDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /coworking-space/set-availabilities',
  back: {
    url: 'POST /coworking-space/set-availabilities',
    controller: 'CoworkingSpaceController',
    action: 'setAvailabilities',
    CODE: 'setAvailabilitiesSpaces'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /coworking-space/delete',
  back: {
    url: 'POST /coworking-space/delete',
    controller: 'CoworkingSpaceController',
    action: 'delete',
    CODE: 'deleteSpace'
  },
  type: 'manageable',
  roles: ['hotelier']
}, /* ------------------------- Booking ------------------------- */

{
  name: 'GET /liste-des-reservations',
  CODE: 'AdminBookingsDashboard',
  front: {
    url: '/liste-des-reservations',
    reactComponent: 'BookingsDashboardPageV2'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'SuperAdminBookingsDashboardPage',
  CODE: 'SuperAdminBookingsDashboard',
  front: {
    url: '/super-admin/liste-des-reservations',
    reactComponent: 'BookingsDashboardPageV2'
  },
  type: 'manageable',
  roles: ['admin']
}, {
  name: 'NewDirectBooking',
  CODE: 'NewDirectBooking',
  front: {
    url: '/nouvelle-reservation-directe',
    reactComponent: 'NewDirectBookingPage'
  },
  type: 'manageable',
  roles: ['admin', 'hotelier']
}, {
  name: 'GET /super-admin/liste-des-reservations-b2b',
  CODE: 'SuperAdminB2BBookingsDashboard',
  front: {
    url: '/super-admin/liste-des-reservations-b2b',
    reactComponent: 'B2BBookingsDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-reservations-b2b',
  CODE: 'AdminB2BBookingsDashboard',
  front: {
    url: '/liste-des-reservations-b2b',
    reactComponent: 'B2BBookingsDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /booking/get-all',
  back: {
    url: 'POST /booking/get-all',
    controller: 'BookingController',
    action: 'getAll',
    CODE: 'getAllBookings'
  },
  type: 'manageable',
  roles: ['hotelier', 'customer', 'company', 'company_employee', 'marketing']
}, {
  name: 'POST /booking/create',
  back: {
    url: 'POST /booking/create',
    controller: 'BookingController',
    action: 'create',
    CODE: 'CreateBooking'
  },
  type: 'public'
}, {
  name: 'POST /booking/create-back',
  back: {
    url: 'POST /booking/create-back',
    controller: 'BookingController',
    action: 'createBack',
    CODE: 'CreateBookingBack'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /booking/create-direct',
  back: {
    url: 'POST /booking/create-direct',
    controller: 'BookingController',
    action: 'createDirectBooking',
    CODE: 'CreateDirectBooking'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /booking/init-payment',
  back: {
    url: 'POST /booking/init-payment',
    controller: 'BookingController',
    action: 'initPayment',
    CODE: 'InitSaferPayPayment'
  },
  type: 'public'
}, {
  name: 'POST /booking/authorize-payment',
  back: {
    url: 'POST /booking/authorize-payment',
    controller: 'BookingController',
    action: 'authorizePayment',
    CODE: 'AuthorizePayment'
  },
  type: 'public'
}, {
  name: 'POST /booking/cancel-booking-services',
  back: {
    url: 'POST /booking/cancel-booking-services',
    controller: 'AddServicesController',
    action: 'cancelBookingServices',
    CODE: 'cancelBookingServices'
  },
  type: 'public'
}, {
  name: 'TestSaferPay',
  back: {
    url: 'POST /booking/test-safer-pay',
    controller: 'BookingController',
    action: 'TestSaferPay',
    CODE: 'TestSaferPay'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'TestPlanetPayment',
  back: {
    url: 'POST /test/planet-payment-config',
    controller: 'PlanetPaymentController',
    action: 'testConfig',
    CODE: 'TestPlanetPayment'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /liste-des-abonnements',
  CODE: 'AdminSubscriptionsDashboard',
  front: {
    url: '/liste-des-abonnements',
    reactComponent: 'SubscriptionsDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'GET /liste-des-abonnements/nouvel-abonnement',
  CODE: 'NewSubscription',
  front: {
    url: '/liste-des-abonnements/nouvel-abonnement',
    reactComponent: 'NewSubscriptionPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /subscription/authorize-payment',
  back: {
    url: 'POST /subscription/authorize-payment',
    controller: 'SubscriptionController',
    action: 'authorizeSubscriptionPayment',
    CODE: 'AuthorizeSubscriptionPayment'
  },
  type: 'public'
}, {
  name: 'POST /subscription/get-all',
  back: {
    url: 'POST /subscription/get-all',
    controller: 'SubscriptionController',
    action: 'getAll',
    CODE: 'getAllSubscriptions'
  },
  type: 'public'
}, {
  name: 'POST /subscription/init-payment',
  back: {
    url: 'POST /subscription/init-payment',
    controller: 'SubscriptionController',
    action: 'initPayment',
    CODE: 'InitilizeSubscriptionPayment'
  },
  type: 'public'
}, {
  name: 'POST /subscription/create',
  back: {
    url: 'POST /subscription/create',
    controller: 'SubscriptionController',
    action: 'create',
    CODE: 'CreateSubscriptionPayment'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /booking/cancel-booking',
  back: {
    url: 'POST /booking/cancel-booking',
    controller: 'BookingController',
    action: 'cancelBooking',
    CODE: 'cancelBooking'
  },
  type: 'public'
}, {
  name: 'CancelBookingPage',
  CODE: 'CancelBookingPage',
  front: {
    url: '/annulation-de-reservation/:token',
    reactComponent: 'CancelBookingPage'
  },
  type: 'public'
}, {
  name: 'CancelBookingServicesPage',
  CODE: 'CancelBookingServicesPage',
  front: {
    url: '/annulation-de-reservation/services/:token',
    reactComponent: 'CancelBookingServicesPage'
  },
  type: 'public'
}, {
  name: 'AddBookingServicesPage',
  CODE: 'AddBookingServicesPage',
  front: {
    url: '/ajout-de-services-a-une-reservation/:token',
    reactComponent: 'AddBookingServicesPage'
  },
  type: 'public'
}, {
  name: 'PayBookingServicesPage',
  CODE: 'PayBookingServicesPage',
  front: {
    url: '/paiement-de-services-additionnels/:token',
    reactComponent: 'PayBookingServicesPage'
  },
  type: 'public'
}, {
  name: 'POST /booking/cancel-company-booking',
  back: {
    url: 'POST /booking/cancel-company-booking',
    controller: 'PackOrderController',
    action: 'cancelCompanyBooking',
    CODE: 'cancelCompanyBooking'
  },
  type: 'public'
}, {
  name: 'POST /booking/add-booking-services',
  back: {
    url: 'POST /booking/add-booking-services',
    controller: 'AddServicesController',
    action: 'addBookingServices',
    CODE: 'addBookingServices'
  },
  type: 'public'
}, {
  name: 'CancelCompanyBookingPage',
  CODE: 'CancelCompanyBookingPage',
  front: {
    url: '/annulation-de-reservation-entreprise',
    reactComponent: 'CancelCompanyBookingPage'
  },
  type: 'public'
}, {
  name: 'verifyCompanyBookingToken',
  back: {
    url: 'POST /booking/verify-company-token',
    controller: 'PackOrderController',
    action: 'verifyToken',
    CODE: 'verifyCompanyBookingToken'
  },
  type: 'public'
}, {
  name: 'verifyBookingToken',
  back: {
    url: 'POST /booking/verify-token',
    controller: 'BookingController',
    action: 'verifyToken',
    CODE: 'verifyBookingToken'
  },
  type: 'public'
}, {
  name: 'verifyPayServicesToken',
  back: {
    url: 'POST /booking/verify-pay-services-token',
    controller: 'AddServicesController',
    action: 'verifyPayToken',
    CODE: 'verifyPayServicesToken'
  },
  type: 'public'
}, {
  name: 'getBookingPDF',
  back: {
    url: 'GET /reservation/PDF/:booking_id',
    controller: 'PDFController',
    action: 'getBookingPDF',
    CODE: 'getBookingPDF'
  },
  type: 'manageable',
  roles: ['customer', 'hotelier']
}, {
  name: 'POST /booking/get-space-booking',
  back: {
    url: 'POST /booking/get-space-booking',
    controller: 'BookingController',
    action: 'getSpaceBooking',
    CODE: 'getSpaceBooking'
  },
  type: 'public'
}, {
  name: 'GET /liste-des-arrives-du-jour',
  CODE: 'AdminArrivalsDashboard',
  front: {
    url: '/liste-des-arrives-du-jour',
    reactComponent: 'ArrivalsDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /booking/update-arrival-status',
  back: {
    url: 'POST /booking/update-arrival-status',
    controller: 'BookingController',
    action: 'updateArrivalStatus',
    CODE: 'updateArrivalStatus'
  },
  type: 'manageable',
  roles: ['hotelier']
}, {
  name: 'POST /booking/update-booking-hours',
  back: {
    url: 'POST /booking/update-booking-hours',
    controller: 'BookingController',
    action: 'updateBookingHours',
    CODE: 'updateBookingHours'
  },
  type: 'AdminOnly'
}, {
  name: 'SetBookingComment',
  back: {
    url: 'POST /booking/set-booking-comment',
    controller: 'BookingController',
    action: 'setBookingComment',
    CODE: 'SetBookingComment'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, /* ------------------------- Newsletter ------------------------- */

{
  name: 'POST /newsletter/is-registered',
  back: {
    url: 'POST /newsletter/is-registered',
    controller: 'NewsletterController',
    action: 'isRegistered',
    CODE: 'IsInNewsletter'
  },
  type: 'public'
}, {
  name: 'POST /newsletter/create',
  back: {
    url: 'POST /newsletter/create',
    controller: 'NewsletterController',
    action: 'create',
    CODE: 'addUserToNewsletter'
  },
  type: 'public'
}, {
  name: 'POST /newsletter/delete',
  back: {
    url: 'POST /newsletter/delete',
    controller: 'NewsletterController',
    action: 'delete'
  },
  type: 'public'
}, /* ------------------------- News ------------------------- */

{
  name: 'GET /liste-des-actualites',
  CODE: 'AdminNewsDashboard',
  front: {
    url: '/liste-des-actualites',
    reactComponent: 'NewsDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /super-admin/liste-des-actualites',
  CODE: 'SuperAdminNewsDashboard',
  front: {
    url: '/super-admin/liste-des-actualites',
    reactComponent: 'NewsDashboardPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /super-admin/liste-des-actualites/nouvelle-actualite',
  CODE: 'SuperAdminNewNews',
  front: {
    url: '/super-admin/liste-des-actualites/nouvelle-actualite',
    reactComponent: 'NewNewsPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-actualites/nouvelle-actualite',
  CODE: 'NewNews',
  front: {
    url: '/liste-des-actualites/nouvelle-actualite',
    reactComponent: 'NewNewsPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /super-admin/liste-des-actualites/:id',
  CODE: 'SuperAdminUpdateNewsPage',
  front: {
    url: '/super-admin/liste-des-actualites/:id',
    reactComponent: 'UpdateNewsPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-actualites/:id',
  CODE: 'UpdateNewsPage',
  front: {
    url: '/liste-des-actualites/:id',
    reactComponent: 'UpdateNewsPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /news/get-all',
  back: {
    url: 'POST /news/get-all',
    controller: 'NewsController',
    action: 'getAll',
    CODE: 'getAllNews'
  },
  type: 'public'
}, {
  name: 'POST /news/create',
  back: {
    url: 'POST /news/create',
    controller: 'NewsController',
    action: 'create',
    CODE: 'createNews'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /news/update',
  back: {
    url: 'POST /news/update',
    controller: 'NewsController',
    action: 'update',
    CODE: 'updateNews'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /news/delete',
  back: {
    url: 'POST /news/delete',
    controller: 'NewsController',
    action: 'delete'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, /* ------------------------- Pages ------------------------- */

{
  name: 'GET /liste-des-pages',
  CODE: 'AdminPagesDashboard',
  front: {
    url: '/liste-des-pages',
    reactComponent: 'PagesDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-pages/nouvelle-page',
  CODE: 'NewPage',
  front: {
    url: '/liste-des-pages/nouvelle-page',
    reactComponent: 'NewPagePage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-pages/:id',
  front: {
    url: '/liste-des-pages/:id',
    reactComponent: 'UpdatePagePage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /page/get-all',
  back: {
    url: 'POST /page/get-all',
    controller: 'PageController',
    action: 'getAll',
    CODE: 'getAllPages'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /page/create',
  back: {
    url: 'POST /page/create',
    controller: 'PageController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /page/update',
  back: {
    url: 'POST /page/update',
    controller: 'PageController',
    action: 'update'
  },
  type: 'AdminOnly'
}, /* --------------------- Discount codes --------------------- */

{
  name: 'GET /liste-des-codes-promos',
  CODE: 'DiscountCodesDashboard',
  front: {
    url: '/liste-des-codes-promos',
    reactComponent: 'DiscountCodesDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-codes-promos/ajouter-un-code-promo',
  CODE: 'NewDiscountCode',
  front: {
    url: '/liste-des-codes-promos/ajouter-un-code-promo',
    reactComponent: 'NewDiscountCodePage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /liste-des-codes-promos/:id',
  CODE: 'UpdateDiscountCode',
  front: {
    url: '/liste-des-codes-promos/:id',
    reactComponent: 'UpdateDiscountCodePage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /discount-code/get-all',
  back: {
    url: 'POST /discount-code/get-all',
    controller: 'DiscountCodeController',
    action: 'getAll',
    CODE: 'getAllDiscountCodes'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /discount-code/create',
  back: {
    url: 'POST /discount-code/create',
    controller: 'DiscountCodeController',
    action: 'create'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /discount-code/update',
  back: {
    url: 'POST /discount-code/update',
    controller: 'DiscountCodeController',
    action: 'update'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /discount-code/check',
  back: {
    url: 'POST /discount-code/check',
    controller: 'DiscountCodeController',
    action: 'check',
    CODE: 'CheckDiscountCode'
  },
  type: 'public'
},
/*
	========================================================
	---------------------- Indicateurs ---------------------
	========================================================
*/

{
  name: 'GET /indicateurs/lounge',
  CODE: 'LoungeIndicator',
  front: {
    url: '/indicateurs/lounge',
    reactComponent: 'LoungeIndicatorPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /super-admin-indicateurs/lounge',
  CODE: 'SuperAdminLoungeIndicator',
  front: {
    url: '/super-admin-indicateurs/lounge',
    reactComponent: 'LoungeIndicatorPage'
  },
  type: 'adminOnly'
}, {
  name: 'GET /indicateurs/meeting',
  CODE: 'MeetingIndicator',
  front: {
    url: '/indicateurs/meeting',
    reactComponent: 'MeetingIndicatorPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /super-admin-indicateurs/meeting',
  CODE: 'SuperAdminMeetingIndicator',
  front: {
    url: '/super-admin-indicateurs/meeting',
    reactComponent: 'MeetingIndicatorPage'
  },
  type: 'adminOnly'
}, {
  name: 'GET /indicateurs/global',
  CODE: 'GlobalIndicator',
  front: {
    url: '/indicateurs/global',
    reactComponent: 'GlobalIndicatorPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /super-admin-indicateurs/global',
  CODE: 'SuperAdminGlobalIndicator',
  front: {
    url: '/super-admin-indicateurs/global',
    reactComponent: 'GlobalIndicatorPage'
  },
  type: 'adminOnly'
}, {
  name: 'GET /indicateurs/services',
  CODE: 'ServicesIndicator',
  front: {
    url: '/indicateurs/services',
    reactComponent: 'ServicesIndicatorPage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'GET /super-admin-indicateurs/services',
  CODE: 'SuperAdminServicesIndicator',
  front: {
    url: '/super-admin-indicateurs/services',
    reactComponent: 'ServicesIndicatorPage'
  },
  type: 'adminOnly'
}, {
  name: 'GET /super-admin-indicateurs/codes-promo',
  CODE: 'SuperAdminDiscountCodesIndicator',
  front: {
    url: '/super-admin-indicateurs/codes-promo',
    reactComponent: 'DiscountCodesIndicatorPage'
  },
  type: 'adminOnly'
}, {
  name: 'GET /indicateurs-global',
  CODE: 'AdminGlobalIndicator',
  front: {
    url: '/indicateurs-global',
    reactComponent: 'AdminGlobalIndicatorPage'
  },
  type: 'manageable',
  roles: ['admin']
}, {
  name: 'POST /stat/get-ca',
  back: {
    url: 'POST /stat/get-ca',
    controller: 'StatController',
    action: 'getCA',
    CODE: 'getCA'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-ca-without-services',
  back: {
    url: 'POST /stat/get-ca-without-services',
    controller: 'StatController',
    action: 'getCAWithoutServices',
    CODE: 'getCAWithoutServices'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-cart-average',
  back: {
    url: 'POST /stat/get-cart-average',
    controller: 'StatController',
    action: 'getCartAverage',
    CODE: 'getCartAverage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-cart-average-without-services',
  back: {
    url: 'POST /stat/get-cart-average-without-services',
    controller: 'StatController',
    action: 'getCartAverageWithoutServices',
    CODE: 'getCartAverageWithoutServices'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-transaction-count',
  back: {
    url: 'POST /stat/get-transaction-count',
    controller: 'StatController',
    action: 'getTransactionCount',
    CODE: 'getTransactionCount'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-total-people-count',
  back: {
    url: 'POST /stat/get-total-people-count',
    controller: 'StatController',
    action: 'getTotalPeopleCount',
    CODE: 'getTotalPeopleCount'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-people-count-average',
  back: {
    url: 'POST /stat/get-people-count-average',
    controller: 'StatController',
    action: 'getPeopleCountAverage',
    CODE: 'getPeopleCountAverage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-lounge-duration',
  back: {
    url: 'POST /stat/get-lounge-duration',
    controller: 'StatController',
    action: 'getLoungeDuration',
    CODE: 'getLoungeDuration'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-lounge-duration-average',
  back: {
    url: 'POST /stat/get-lounge-duration-average',
    controller: 'StatController',
    action: 'getLoungeDurationAverage',
    CODE: 'getLoungeDurationAverage'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-lounge-transaction-by-hours',
  back: {
    url: 'POST /stat/get-lounge-transaction-by-hours',
    controller: 'StatController',
    action: 'getLoungeTransactionByHours',
    CODE: 'getLoungeTransactionByHours'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-booking-window',
  back: {
    url: 'POST /stat/get-booking-window',
    controller: 'StatController',
    action: 'getBookingWindow',
    CODE: 'getBookingWindow'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-transaction-count-by-seminar-type',
  back: {
    url: 'POST /stat/get-transaction-count-by-seminar-type',
    controller: 'StatController',
    action: 'getTransactionCountBySeminarType',
    CODE: 'getTransactionCountBySeminarType'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-subscription-count',
  back: {
    url: 'POST /stat/get-subscription-count',
    controller: 'StatController',
    action: 'getSubscriptionCount',
    CODE: 'getSubscriptionCount'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-ca-services',
  back: {
    url: 'POST /stat/get-ca-services',
    controller: 'StatController',
    action: 'getCAServices',
    CODE: 'getCAServices'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/get-ca-by-services',
  back: {
    url: 'POST /stat/get-ca-by-services',
    controller: 'StatController',
    action: 'getCAByServices',
    CODE: 'getCAByServices'
  },
  type: 'manageable',
  roles: ['hotelier', 'admin']
}, {
  name: 'POST /stat/discount-codes',
  back: {
    url: 'POST /stat/discount-codes',
    controller: 'StatController',
    action: 'discountCodes',
    CODE: 'DiscountCodesStats'
  },
  type: 'manageable',
  roles: 'adminOnly'
},
/*
	========================================================
	------------------ Admin pre-bookings ------------------
	========================================================
*/
/* ------------------- Statistics ------------------- */

{
  name: 'GET /offline/indicateurs',
  CODE: 'AdminBookingsStats',
  front: {
    url: '/offline/indicateurs',
    reactComponent: 'AdminBookingStatsPage'
  },
  type: 'manageable',
  roles: ['admin']
}, {
  name: 'POST /stat/get-admin-bookings',
  back: {
    url: 'POST /stat/get-admin-bookings',
    controller: 'StatController',
    action: 'adminBookings',
    CODE: 'GetAdminBookingsStats'
  },
  type: 'AdminOnly'
}, /* ------------------ Subscriptions ----------------- */

{
  name: 'GET /offline/abonnements',
  CODE: 'PreSubscriptionsDashboard',
  front: {
    url: '/offline/abonnements',
    reactComponent: 'SubscriptionsDashboardPage'
  },
  type: 'AdminOnly'
},
// {
// 	name: 'NewSubscription',

// 	CODE: 'NewPreSubscription',

// 	front:
// 	{
// 		url: '/offline/abonnements/nouvel-abonnement',
// 		reactComponent: 'NewSubscriptionPage'
// 	},

// 	type: 'AdminOnly'
// },

/* -------------------- Bookings -------------------- */

{
  name: 'AdminBookingsModuleDashboard',
  CODE: 'AdminBookingsModuleDashboard',
  front: {
    url: '/offline/gestion',
    reactComponent: 'BookingsModuleDashboardPage'
  },
  type: 'AdminOnly'
}, {
  name: 'GET /offline/nouvelle-reservation',
  CODE: 'NewModuleBooking',
  front: {
    url: '/offline/nouvelle-reservation',
    reactComponent: 'NewModuleBookingPage'
  },
  type: 'AdminOnly'
}, {
  name: 'POST /token/verify-back-payment-token',
  back: {
    url: 'POST /token/verify-back-payment-token',
    controller: 'TokenController',
    action: 'verifyBackPaymentToken',
    CODE: 'verifyBackPaymentToken'
  },
  type: 'public'
}, {
  name: 'POST /token/verify-back-subscription-payment-token',
  back: {
    url: 'POST /token/verify-back-subscription-payment-token',
    controller: 'TokenController',
    action: 'verifyBackSubscriptionPaymentToken',
    CODE: 'verifyBackSubscriptionPaymentToken'
  },
  type: 'public'
}, {
  name: 'POST /booking/cancel-back',
  back: {
    url: 'POST /booking/cancel-back',
    controller: 'BookingController',
    action: 'cancelPreReservation',
    CODE: 'cancelPreReservation'
  },
  type: 'AdminOnly'
},
/*
	========================================================
	------------------------- Auth -------------------------
	========================================================
*/
{
  name: 'POST /get-session',
  back: {
    url: 'POST /get-session',
    controller: 'SessionController',
    action: 'get'
  },
  type: 'public'
}, {
  name: 'POST /login',
  back: {
    CODE: 'log-user',
    url: 'POST /login',
    controller: 'AuthController',
    action: 'login'
  },
  type: 'public'
}, {
  name: 'PassportAuth',
  Passport: {
    Strategy: 'Google',
    type: 'login'
  },
  back: {
    CODE: 'PassportAuth',
    url: 'GET /login/passport',
    controller: 'PassportController',
    action: 'authenticate'
  },
  type: 'public'
}, {
  name: 'GoogleOAuthRedirect',
  Passport: {
    Strategy: 'Google',
    type: 'redirect'
  },
  back: {
    CODE: 'GoogleOAuthRedirect',
    url: 'GET /oauth2/redirect/google',
    controller: 'PassportController',
    action: 'googleRedirect'
  },
  type: 'public'
}, {
  name: 'LinkedInOAuthRedirect',
  Passport: {
    Strategy: 'LinkedIn',
    type: 'redirect'
  },
  back: {
    CODE: 'LinkedInOAuthRedirect',
    url: 'GET /oauth2/redirect/linkedin',
    controller: 'PassportController',
    action: 'linkedInRedirect'
  },
  type: 'public'
}, {
  name: 'POST /company-login',
  back: {
    CODE: 'log-company',
    url: 'POST /company-login',
    controller: 'AuthController',
    action: 'companyLogin'
  },
  type: 'public'
}, {
  name: 'POST /logout',
  back: {
    url: 'POST /logout',
    controller: 'AuthController',
    action: 'logout'
  },
  type: 'public'
}, {
  name: 'GET /authentification/mot-de-passe-oublie',
  CODE: 'PasswordRecovery',
  front: {
    url: '/authentification/mot-de-passe-oublie',
    reactComponent: 'PasswordRecoveryPage'
  },
  type: 'public'
}, {
  name: 'ForgottenPasswordPage',
  CODE: 'ForgottenPassword',
  front: {
    url: '/authentification/mot-de-passe-oublie/nouveau-mot-de-passe/:token',
    reactComponent: 'ForgottenPasswordPage'
  },
  type: 'public'
}, {
  name: 'POST /user/recover-password',
  back: {
    url: 'POST /user/recover-password',
    controller: 'UserController',
    action: 'recoverPassword'
  },
  type: 'public'
}, {
  name: 'POST /token/verify-password-recovery-token',
  back: {
    url: 'POST /token/verify-password-recovery-token',
    controller: 'TokenController',
    action: 'verifyPasswordRecovery'
  },
  type: 'public'
}, {
  name: 'POST /user/new-password',
  back: {
    url: 'POST /user/new-password',
    controller: 'UserController',
    action: 'newPassword'
  },
  type: 'public'
}, {
  name: 'POST /user/delete',
  back: {
    url: 'POST /user/delete',
    controller: 'UserController',
    action: 'delete'
  },
  type: 'adminOnly'
},
/*
	========================================================
	--------------------- Autocompletes --------------------
	========================================================
*/

{
  name: 'AutocompletePage',
  back: {
    CODE: 'AutocompletePage',
    url: 'POST /autocomplete/page',
    controller: 'AutocompleteController',
    action: 'getPageResults'
  },
  type: 'AdminOnly'
}, {
  name: 'AutocompleteCity',
  back: {
    CODE: 'AutocompleteCity',
    url: 'POST /autocomplete/cities',
    controller: 'AutocompleteController',
    action: 'getCitiesResults'
  },
  type: 'public'
}, {
  name: 'AutocompleteAdmins',
  back: {
    CODE: 'AutocompleteAdmins',
    url: 'POST /autocomplete/admins',
    controller: 'AutocompleteController',
    action: 'getAdminsResults'
  },
  type: 'AdminOnly'
}, {
  name: 'AutocompleteEtablishments',
  back: {
    CODE: 'AutocompleteEtablishments',
    url: 'POST /autocomplete/etablishments',
    controller: 'AutocompleteController',
    action: 'getEtablishmentsResults'
  },
  type: 'AdminOnly'
},
/*
========================================================
--------------------- Payment Kits ---------------------
========================================================
*/

{
  name: 'GetPlanetiPageToken',
  back: {
    CODE: 'GetPlanetiPageToken',
    url: 'POST /payment/planet/get-iPage-token',
    controller: 'PlanetPaymentController',
    action: 'getiPageToken'
  },
  type: 'public'
}, {
  name: 'PlanetPostSuccess',
  back: {
    CODE: 'PlanetPostSuccess',
    url: 'POST /payment/planet/success',
    controller: 'PlanetPaymentController',
    action: 'postSuccess',
    cors: {
      allowOrigins: '*',
      allowCredentials: false
    }
  },
  type: 'public'
}, {
  name: 'PlanetPostFailure',
  back: {
    CODE: 'PlanetPostFailure',
    url: 'POST /payment/planet/failure',
    controller: 'PlanetPaymentController',
    action: 'postFailure',
    cors: {
      allowOrigins: '*',
      allowCredentials: false
    }
  },
  type: 'public'
}, {
  name: 'PlanetPaymentRedirectOK',
  CODE: 'PlanetPaymentRedirectOK',
  front: {
    url: '/paiement/planet/confirmation',
    reactComponent: 'RedirectOKPage'
  },
  type: 'public'
}, {
  name: 'PlanetPaymentRedirectFailure',
  CODE: 'PlanetPaymentRedirectFailure',
  front: {
    url: '/paiement/planet/echec',
    reactComponent: 'RedirectFailurePage'
  },
  type: 'public'
}, {
  name: 'PlanetPaymentRedirectCancel',
  CODE: 'PlanetPaymentRedirectCancel',
  front: {
    url: '/paiement/planet/annulation',
    reactComponent: 'RedirectCancelPage'
  },
  type: 'public'
}, {
  name: 'IframeLoaderOK',
  CODE: 'IframeLoaderOK',
  front: {
    url: '/paiement/iframe/ok',
    reactComponent: 'IframeLoaderPage'
  },
  type: 'public'
}, {
  name: 'IframeLoaderKO',
  CODE: 'IframeLoaderKO',
  front: {
    url: '/paiement/iframe/ko',
    reactComponent: 'IframeLoaderPage'
  },
  type: 'public'
}, {
  name: 'LibConfirmationPage',
  CODE: 'LibConfirmationPage',
  front: {
    url: '/reserver-en-ligne/confirmation',
    reactComponent: 'LibConfirmationPage'
  },
  type: 'public'
}, {
  name: 'StripePaymentRedirectOK',
  CODE: 'StripePaymentRedirectOK',
  front: {
    url: '/paiement/stripe/confirmation',
    reactComponent: 'RedirectOKPage'
  },
  type: 'public'
}, {
  name: 'StripePaymentRedirectFailure',
  CODE: 'StripePaymentRedirectFailure',
  front: {
    url: '/paiement/stripe/echec',
    reactComponent: 'RedirectFailurePage'
  },
  type: 'public'
}, {
  name: 'StripePaymentRedirectCancel',
  CODE: 'StripePaymentRedirectCancel',
  front: {
    url: '/paiement/stripe/annulation',
    reactComponent: 'RedirectCancelPage'
  },
  type: 'public'
}, {
  name: 'TestStripePaymentKit',
  back: {
    CODE: 'TestStripePaymentKit',
    url: 'POST /stripe/test-payment-kit',
    controller: 'StripeController',
    action: 'testPaymentKit'
  },
  type: 'adminOnly'
},
/*
========================================================
------------------------- Stripe ------------------------
========================================================
*/

{
  name: 'GetStripePublicKey',
  back: {
    CODE: 'GetStripePublicKey',
    url: 'POST /stripe/get-public-key-from-booking',
    controller: 'StripeController',
    action: 'getPublicKey'
  },
  type: 'public'
}, {
  name: 'GetStripeIntent',
  back: {
    CODE: 'GetStripeIntent',
    url: 'POST /stripe/get-booking-payment-intent',
    controller: 'StripeController',
    action: 'getIntentAndCustomer'
  },
  type: 'public'
}, {
  name: 'ValidateStripePayment',
  back: {
    CODE: 'ValidateStripePayment',
    url: 'POST /stripe/confirm-intent',
    controller: 'StripeController',
    action: 'validate'
  },
  type: 'public'
}, {
  name: 'ValidatePackOrderStripePayment',
  back: {
    CODE: 'ValidatePackOrderStripePayment',
    url: 'POST /stripe/confirm-packorder-intent',
    controller: 'StripeController',
    action: 'validatePackOrder'
  },
  type: 'public'
}, {
  name: 'StripePaymentError',
  back: {
    CODE: 'StripePaymentError',
    url: 'POST /stripe/booking-payment-error',
    controller: 'StripeController',
    action: 'onBookingPaymentError'
  },
  type: 'public'
}, {
  name: 'GetSessionBooking',
  back: {
    CODE: 'GetSessionBooking',
    url: 'POST /get-current-booking',
    controller: 'BookingController',
    action: 'getCurrent'
  },
  type: 'public'
}, {
  name: 'ValidateServicesStripePayment',
  back: {
    url: 'POST /booking/validate-services-stripe-payment',
    controller: 'StripeController',
    action: 'validateServicesPayment',
    CODE: 'ValidateServicesStripePayment'
  },
  type: 'public'
},
/*
========================================================
----------------------- Exports ------------------------
========================================================
*/

{
  name: 'exportConfiguredServices',
  back: {
    CODE: 'ExportConfiguredServices',
    url: 'GET /export/services-configures',
    controller: 'ExportController',
    action: 'exportConfiguredServices',
    skipAssets: false
  },
  type: 'adminOnly'
}, {
  name: 'exportPurchasedServices',
  back: {
    CODE: 'ExportPurchasedServices',
    url: 'GET /export/conso-services',
    controller: 'ExportController',
    action: 'exportPurchasedServices',
    skipAssets: false
  },
  type: 'adminOnly'
}

/*
========================================================
------------------------- Tests ------------------------
========================================================
*/

// {
// 	name: 'TestSatisfactionTemplate',

// 	back:
// 	{
// 		url: 'POST /tests/email-satisfaction-template',
// 		controller: 'TestController',
// 		action: 'satisfactionTemplate'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestMeetingConfirmationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-meeting-confirmation',
// 		controller: 'TestController',
// 		action: 'meetingConfirmation'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestLoungeConfirmationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-lounge-confirmation',
// 		controller: 'TestController',
// 		action: 'loungeConfirmation'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestLibConfirmationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-lib-confirmation',
// 		controller: 'TestController',
// 		action: 'libConfirmation'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestLibCancelConfirmationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-lib-cancel-confirmation',
// 		controller: 'TestController',
// 		action: 'cancelLibConfirmation'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestMeetingCancelConfirmationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-meeting-cancel-confirmation',
// 		controller: 'TestController',
// 		action: 'cancelMeetingConfirmation'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestLoungeCancelConfirmationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-lounge-cancel-confirmation',
// 		controller: 'TestController',
// 		action: 'cancelLoungeConfirmation'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestNewAccountEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-new-account',
// 		controller: 'TestController',
// 		action: 'newAccountEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestNewSubscriptionEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-new-subscription',
// 		controller: 'TestController',
// 		action: 'newSubscriptionEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestNewWalletEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-new-wallet',
// 		controller: 'TestController',
// 		action: 'newWalletEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestNewBackBookingEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-new-back-booking',
// 		controller: 'TestController',
// 		action: 'newBackBookingEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestPaidBackBookingEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-paid-back-booking',
// 		controller: 'TestController',
// 		action: 'newPaidBackBooking'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestBackSubscriptionEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-back-subscription',
// 		controller: 'TestController',
// 		action: 'backSubscriptionEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestSubscriptionReminderEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-subscription-reminder',
// 		controller: 'TestController',
// 		action: 'subscriptionReminderEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestSubscriptionTokenExpirationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-subscription-token-expiration',
// 		controller: 'TestController',
// 		action: 'subscriptionTokenExpirationEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestNewCompanyAccountEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-new-company',
// 		controller: 'TestController',
// 		action: 'sendNewCompanyAccountEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestNewCompanyAccountByAdminEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-new-company-by-admin',
// 		controller: 'TestController',
// 		action: 'sendNewCompanyAccountByAdminEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestNewPackOrderEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-new-pack-order',
// 		controller: 'TestController',
// 		action: 'sendPackOrderEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestPackOrderFormEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-pack-order-form',
// 		controller: 'TestController',
// 		action: 'sendPackOrderFormEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestCompanyReservationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-company-order-confirmation',
// 		controller: 'TestController',
// 		action: 'sendCompanyReservationEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestCompanyCanceledReservationEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-company-order-cancel-confirmation',
// 		controller: 'TestController',
// 		action: 'sendCanceledReservationEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestPackOverCapacityEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-pack-over-capacity',
// 		controller: 'TestController',
// 		action: 'sendPackOverCapacityEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestPackEmptyEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-pack-empty',
// 		controller: 'TestController',
// 		action: 'sendPackEmptyEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'sendPackExpirationDateEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-pack-expiration-notification',
// 		controller: 'TestController',
// 		action: 'sendPackExpirationDateEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestPackExpirationDateLimitEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-pack-expired',
// 		controller: 'TestController',
// 		action: 'sendPackExpirationDateLimitEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestPackOrderAdminEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-pack-admin-notif',
// 		controller: 'TestController',
// 		action: 'sendPackOrderAdminEmail'
// 	},

// 	type: 'public'
// },

// {
// 	name: 'TestAvailableArchiveEmail',

// 	back:
// 	{
// 		url: 'POST /tests/email-available-archive',
// 		controller: 'TestController',
// 		action: 'sendArchiveAvailableEmail'
// 	},

// 	type: 'public'
// },

/*
========================================================
----------------------- Migration ----------------------
========================================================
*/

// {
// 	name: 'MigrateServicesTitles',

// 	back:
// 	{
// 		url: 'POST /migrations/migrate-services-titles',
// 		controller: 'MigrationController',
// 		action: 'migrateServicesTitles'
// 	},

// 	type: 'AdminOnly'
// }
];

module.exports.front_urls = module.exports.routes.filter(route => route.CODE && route.front && route.front.url).map(function (route) {
  return {
    CODE: route.CODE,
    url: route.front.url
  };
});
module.exports.URL = function (CODE, routes) {
  const used_routes = routes || module.exports.front_urls;
  return (used_routes.find(data => data.CODE === CODE) || {}).url || '/';
};
module.exports.action = function (CODE) {
  let route = module.exports.routes.find(route => route.back && route.back.CODE === CODE);
  if (!route) return '/404';
  return route.back.url.slice(route.back.url.indexOf('/'));
};
